// extracted by mini-css-extract-plugin
module.exports = {"duo":"form-submission-container_duo__1BuqW","field":"form-submission-container_field__18Uq2"};